<template>
  <section>
    <div class="hero is-large" id="hero-jump-image">
      <div class="background-primary">
        <div class="container has-text-centered">
          <div class="hero-body has-text-white">
            <h1 class="title is-1 has-text-white">WE ARE MARRIED</h1>
            <h2 class="subtitle has-text-light">January 5, 2019 - Lafayette, GA, USA</h2>
          </div>
        </div>
      </div>
    </div>
    <div class="hero is-medium background-primary">
      <div class="hero-body">
        <div class="container has-text-centered">
          <div class="tile is-ancestor">
            <div class="tile is-parent">
              <article class="tile is-child box">
                <p class="title is-1">Our story</p>
                <p class="subtitle is-size-4-desktop is-size-6-mobile">🎓☕🦃🙌❤️💍💒️💃🕺🎉️</p>
                <div class="content">
                  <p>Laura and John met at Georgia Tech in the fall of 2015. Thanks to a good friend, they were
                    introduced to each other over coffee. John was invited to Thanksgiving with Laura’s family. However
                    this
                    is not where the romance began. One year later, after getting to know each other better as friends,
                    John was invited to come back for Thanksgiving again. After some fondue at The Melting Pot, a light
                    clicked. They have been adventuring through the last two years together with more coffee, Turkey and
                    dressing, and lots of late night phone calls.</p>
                  <p class="content">On August 19, 2018, one day after Laura got off a plane, John decided to propose.
                    After many many months of decisions and growing more together, the time couldn’t have been more
                    perfect. They went out for coffee, and then for a walk. At the end of the walk there was a beautiful
                    waterfall. The air was clear, the sky was perfect, and then John got down on one knee. Let the
                    adventure begin!</p>
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hero is-large" id="hero-rings-image">
      <div class="background-primary">
        <div class="container">
          <div class="hero-body">
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--<HelloWorld msg="We're engaged!!"/>-->
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'home',
  components: {
    HelloWorld
  }
}
</script>

<style scoped lang="scss">
  @import "~bulma";

  #hero-jump-image {
    background-image: url("../assets/jump_w_2560.jpg");
    background-position: 10% 20%;
    background-repeat: no-repeat;
    background-size: cover;

    /*object-fit: cover;*/
    /*object-position: 10% 20%;*/
    //height: 100%;
    //width: 100%;
  }

  #hero-rings-image {
    background-image: url("../assets/rings_w_2560.jpg");
    background-position: 50% 100%;
    background-repeat: no-repeat;
    background-size: cover;
  }

  @include until-fullhd {
    #hero-jump-image {
      background-image: url("../assets/jump_w_1600.jpg");
    }
    #hero-rings-image {
      background-image: url("../assets/rings_w_1600.jpg");
    }
  }

  @include mobile {
    #hero-jump-image {
      background-image: url("../assets/jump_w_800.jpg");
    }
    #hero-rings-image {
      background-image: url("../assets/rings_w_800.jpg");
    }
  }

</style>
